import { SalesSectionProps } from '.'

export const swapSectionData: SalesSectionProps = {
  headingText: 'Trade anything. No registration, no hassle.',
  bodyText: 'Trade any token on Binance Smart Chain in seconds, just by connecting your wallet.',
  reverse: false,
  primaryButton: {
    to: '/swap',
    text: 'Trade Now',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.pancakeswap.finance/',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/trade/',
    attributes: [
      { src: 'BNB', alt: 'BNB token' },
      { src: 'BTC', alt: 'BTC token' },
      { src: 'VIZSLASWAP', alt: 'VIZSLASWAP token' },
    ],
  },
  images2: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with VIZSLASWAP token' },
    ],
  },
      images3: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      }, 
      images35: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner35', alt: 'VIZSLASWAP token' },
        ],
      }, 
       images4: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images5: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images6: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      }, 
      images65: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner65', alt: 'VIZSLASWAP token' },
        ],
      }, 
       images7: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images8: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images9: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images10: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
  },
}


export const earnSectionData: SalesSectionProps = {
  headingText: 'Earn passive income with crypto.',
  bodyText: 'VizslaSwap makes it easy to make your crypto work for you.',
  reverse: true,
  primaryButton: {
    to: '/farms',
    text: 'Explore',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.pancakeswap.finance/products/yield-farming',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with VIZSLASWAP token' },
    ],
  },
  images2: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with VIZSLASWAP token' },
    ],
  },
      images3: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      }, 
      images35: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner35', alt: 'VIZSLASWAP token' },
        ],
      }, 
       images4: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images5: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images6: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      }, 
      images65: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner65', alt: 'VIZSLASWAP token' },
        ],
      }, 
       images7: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images8: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images9: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
      },  images10: {
        path: '/images/home/banner/',
        attributes: [
          { src: 'banner2', alt: 'VIZSLASWAP token' },
        ],
  },
}

export const cakeSectionData2: SalesSectionProps = {
  headingText: 'You have 100% ownership of your own crypto.',
  bodyText:
    'We are not trying to replace the swap & exchange but to add value into the ecosystem and create a suitable and sustainable environment for people to liquidity mining and staking pools with high APR. Trade directly from your wallet app and VizslaSwap doesn’t hold your funds when you trade.',
  reverse: false,
  primaryButton: {
    to: '/swap?outputCurrency=0xadaae082237cb1772c9e079db95c117e6dd0c5af',
    text: 'Buy VIZSLASWAP',
    external: false,
  },
  secondaryButton: {
    to: '/swap?outputCurrency=0xDE619A9E0eEeAA9F8CD39522Ed788234837F3B26',
    text: 'Buy HVI',
    external: false,
  },
  images: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner1', alt: 'VIZSLASWAP token' },
    ],
  },
  images2: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner2', alt: 'VIZSLASWAP token' },
    ],
  },
  images3: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner3', alt: 'VIZSLASWAP token' },
    ],
  },
  images35: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner35', alt: 'VIZSLASWAP token' },
    ],
  }, 
    images4: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner4', alt: 'VIZSLASWAP token' },
    ],
  },  images5: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner5', alt: 'VIZSLASWAP token' },
    ],
  },  images6: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner6', alt: 'VIZSLASWAP token' },
    ],
  }, 
  images65: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner65', alt: 'VIZSLASWAP token' },
    ],
  }, 
   images7: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner7', alt: 'VIZSLASWAP token' },
    ],
  },  images8: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner8', alt: 'VIZSLASWAP token' },
    ],
  },  images9: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner9', alt: 'VIZSLASWAP token' },
    ],
  },  images10: {
    path: '/images/home/banner/',
    attributes: [
      { src: 'banner2', alt: 'VIZSLASWAP token' },
    ],
  },
}
